import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { WMICJsonRPCService } from 'wmic-pe-portals-transport-js';


/**
 * Invokes the given method on the backend endpoint passing the given data as parameters
 *
 * @param {any} method the method to invoke on the backend endpoint
 * @param {any} data the data to be passed as part of the invokation on the backend
 * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
 * @returns {Promise} the promise from the backend call
 */
function processSubmission(method, data, additionalHeaders = {}) {
    return WMICJsonRPCService.send(getProxiedServiceUrl('flex'), method, data, additionalHeaders);
}

/**
 * This is the service responsible for common flex functionality.
 *
 * @export
 * @class FlexProgramService
 */
export default class FlexProgramService {
    static recalculateFlexPreview(
        jobID,
        flexDTO,
        additionalHeaders = {}
    ) {
        return processSubmission(
            'recalculateFlexPreview',
            [jobID, flexDTO],
            additionalHeaders
        );
    }
}
